import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { useLanguage } from '../../../../locale/useLanguage';
import { Button } from '../../../Button/Button';
import { Modal, ModalRef } from '../../../Modal/Modal';

import './EditAddressWarningModal.css';

type EditAddressWarningModalProps = {
  onChoosePickUpPoint: () => void;
  onEditAddress: () => void;
};

export const EditAddressWarningModal: React.ForwardRefExoticComponent<
  EditAddressWarningModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ onEditAddress }, forwardedRef) => {
  const [t] = useLanguage();
  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  return (
    <>
      <Modal ref={modalRef}>
        <h3 className="modal-title">
          {t('changeAddress.editAddressWarningModalTitle')}
        </h3>
        <p className="modal-description">
          {t('changeAddress.editAddressWarningModalDescription1')}
        </p>
        <p className="modal-description">
          {t('changeAddress.editAddressWarningModalDescription2')}
        </p>
        <p className="modal-description">
          {t('changeAddress.editAddressWarningModalDescription3')}
        </p>
        <div className="modal-button-container">
          <Button
            onClick={onEditAddress}
            label={t('changeAddress.editAddressWarningModalEditAddress')}
            isPrimary
          />
          {/* TODO: Uncomment when pdr is ready again */}
          {/* <div className="edit-address-warning-modal--exit-button">
            <Button
              onClick={onChoosePickUpPoint}
              label={t(
                'changeAddress.editAddressWarningModalChoosePickUpPoint'
              )}
            />
          </div> */}
        </div>
      </Modal>
    </>
  );
});
